import { useQuery } from "@tanstack/react-query"

import { useFetchFeatureFlags } from "@/hooks/api/feature-flags/queries"
import { useApiContext } from "@/hooks/api/use-api-context"
import { useDevAuth } from "@/hooks/use-dev-auth"

import { fetchBackOffice, fetchBackOffices } from "./api"

export function useFetchBackOffices() {
  const getContext = useApiContext()
  const { isLoaded, isSignedIn, userId } = useDevAuth()
  const featureFlags = useFetchFeatureFlags()
  const enabled = featureFlags.data?.includes("back_office_enabled") ?? false

  const query = useQuery({
    queryKey: ["back-offices", userId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchBackOffices(context)
    },
    enabled: enabled && isLoaded && Boolean(isSignedIn),
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
  return { ...query, data: enabled ? query.data : undefined, isLoading: featureFlags.isLoading || query.isLoading }
}

export function useFetchBackOffice(id: string) {
  const getContext = useApiContext()
  const { isLoaded, isSignedIn } = useDevAuth()
  const { data: featureFlags } = useFetchFeatureFlags()
  const enabled = featureFlags?.includes("back_office_enabled") ?? false

  const query = useQuery({
    queryKey: ["back-office", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchBackOffice(context, id)
    },
    enabled: enabled && !!id && isLoaded && Boolean(isSignedIn),
    retry: false,
  })
  return { ...query, data: enabled ? query.data : undefined }
}
